import * as ng from 'angular';
import { StSelectRowCustom } from './st-select-row-custom.directive';

export const StSelectRowCustomModule: string =
    ng.module('st-select-row-custom', [
    ])
        .directive('stSelectRowCustom', StSelectRowCustom)
        .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/st-select-row-custom/st-select-row-custom.module.ts